module.exports = Promise.all([__parcel__import__("hbwOp"), __parcel__import__("aJtdc")]).then(() => parcelRequire('4MH6n'));